"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewBodyContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _PreviewBody = require("b2b-components/core/components/Gallery/Gallery/PreviewBody/PreviewBody");
const PreviewBodyContainer = props => {
  const {
    images,
    videos,
    ...originalProps
  } = props;
  const {
    image360,
    maxThumbnailCount,
    totalImage360Count,
    totalImageCount,
    totalVideoCount
  } = originalProps;
  const previewImages = images?.length ? images.slice(0, Math.min(maxThumbnailCount, totalImageCount) - (totalImage360Count && Math.min(maxThumbnailCount, totalImageCount) === maxThumbnailCount ? 1 : 0) - (totalVideoCount && totalImage360Count + Math.min(maxThumbnailCount, totalImageCount) === maxThumbnailCount ? 1 : 0)) : null;
  const previewVideos = videos?.length ? videos.slice(0, totalImageCount + totalImage360Count < maxThumbnailCount ? Math.min(maxThumbnailCount - (totalImageCount + totalImage360Count), videos.length) : 1) : null;
  const previewItemIndexArray = [...(previewImages ? Array.from(Array(previewImages.length).keys()) : []), ...(image360 ? [totalImageCount] : []), ...(previewVideos ? Array.from(Array(previewVideos.length).keys()).map(i => image360 ? i + totalImageCount + 1 : i + totalImageCount) : [])];
  return /*#__PURE__*/_react.default.createElement(_PreviewBody.PreviewBody, (0, _extends2.default)({}, originalProps, {
    images: previewImages,
    itemIndexArray: previewItemIndexArray,
    videos: previewVideos
  }));
};
exports.PreviewBodyContainer = PreviewBodyContainer;
//# sourceMappingURL=PreviewBodyContainer.js.map